<template>
    <div class="vimeo-video">
        <slot></slot>
        <vimeo-player ref="player"
            :video-id="videoID"
            @ready="onReady"
            :player-height="height"
            :controls="false"
            :loop="true"
            :options="options">
        </vimeo-player>
    </div>
</template>

<script>
    import { vueVimeoPlayer } from 'vue-vimeo-player'
    export default {
        components: { vueVimeoPlayer },
        data() {
            return {
                videoID: '855518447',
                options: {
                    muted: true,
                    autoplay: true,
                },
                playerReady: false
            }
        },
        methods: {
            onReady() {
                this.playerReady = true
            },
            play () {
                this.$refs.player.play()
            },
            pause () {
                this.$refs.player.pause()
            }
        },
    }
</script>

<style lang="scss">
    .vimeo-video {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
    }
    .vimeo-video > div {
        width: 100%;
        height: 100%;
    }
    .vimeo-video iframe {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
    }
</style>



// WEBPACK FOOTER //
// resources/components/apps/vimeo-component.vue